export const SAMPLER = 'SAMPLER';
export const SAMPLED_INSTRUMENT = 'SAMPLED_INSTRUMENT';
export const SYNTH = 'SYNTH';
export const MULTI_SYNTH = 'MULTI_SYNTH';
export const FM_SYNTH = 'FM_SYNTH';
export const METAL_SYNTH = 'METAL_SYNTH';
export const EXTERNAL_INSTRUMENT = 'EXTERNAL_INSTRUMENT';
export const INSTRUMENT_RACK = 'INSTRUMENT_RACK';
export const EFFECTS = 'EFFECTS';

export const INSTRUMENT_TYPE_TO_NAME =
    {
        SAMPLER: 'Sampler',
        SYNTH: 'Synth',
        MULTI_SYNTH: 'Synth',
        FM_SYNTH: 'FM Synth',
        EXTERNAL_INSTRUMENT: 'External Instrument',
        SAMPLED_INSTRUMENT: 'Sampled Instrument',
        INSTRUMENT_RACK: 'Instrument Rack',
        METAL_SYNTH: 'Metal Synth',
        EFFECTS: 'FX',
    };
